export default [
	{
		category: true,
		title: 'General'
	},
	{
		title: 'Dashboard',
		key: '_home',
		icon: 'tachometer-alt',
		url: {
			name: '_home'
		},
		auth: {
			strict: false,
			roles: ['_BOSS']
		}
	},
	{
		category: true,
		title: 'Gestión de clientes'
	},
	{
		title: 'Empresas',
		key: 'empresas',
		icon: 'building',
		children: [
			{
				title: 'Listado',
				key: 'empresas',
				icon: ['far', 'file-alt'],
				url: {
					name: 'empresas'
				},
				auth: {
					strict: false,
					roles: ['view.empresas', 'view.mine.empresas']
				}
			},
			{
				title: 'Nueva empresa',
				key: 'empresas_new',
				icon: ['far', 'plus-square'],
				url: {
					name: 'empresas_new'
				},
				auth: {
					strict: false,
					roles: ['add.empresas', 'add.mod.empresas']
				}
			}
		],
		auth: {
			strict: false,
			roles: ['view.empresas', 'view.mine.empresas']
		}
	},
	{
		category: true,
		title: 'Facturación'
	},
	{
		title: 'Productos',
		key: 'productos',
		icon: 'box-open',
		url: {
			name: 'productos'
		},
		auth: {
			strict: false,
			roles: ['view.productos', 'view.mine.productos']
		}
	},
	{
		title: 'Series',
		key: 'series',
		icon: 'qrcode',
		url: {
			name: 'series'
		},
		auth: {
			strict: false,
			roles: ['_BOSS']
		}
	},
	{
		title: 'Facturas',
		key: 'facturas',
		icon: 'file-invoice',
		children: [
			{
				title: 'Listado',
				key: 'facturas',
				icon: ['far', 'list-alt'],
				url: {
					name: 'facturas'
				},
				auth: {
					strict: false,
					roles: ['view.facturas', 'view.mine.facturas']
				}
			},
			{
				title: 'Nueva factura',
				key: 'facturas_new',
				icon: ['far', 'plus-square'],
				url: {
					name: 'facturas_new'
				},
				auth: {
					strict: false,
					roles: ['add.facturas', 'add.mod.facturas']
				}
			}
		],
		auth: {
			strict: false,
			roles: ['view.facturas', 'view.mine.facturas']
		}
	},
	{
		title: 'Presupuestos',
		key: 'presupuestos',
		icon: 'receipt',
		children: [
			{
				title: 'Listado',
				key: 'presupuestos',
				icon: ['far', 'file-alt'],
				url: {
					name: 'presupuestos'
				},
				auth: {
					strict: false,
					roles: ['view.presupuestos', 'view.mine.presupuestos']
				}
			},
			{
				title: 'Nuevo presupuesto',
				key: 'presupuestos_new',
				icon: ['far', 'plus-square'],
				url: {
					name: 'presupuestos_new'
				},
				auth: {
					strict: false,
					roles: ['add.presupuestos', 'add.mod.presupuestos']
				}
			}
		],
		auth: {
			strict: false,
			roles: ['view.presupuestos', 'view.mine.presupuestos']
		}
	}
];
